import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";

const RedFlags = () => {
    const { analysis } = useSelector((state) => state.tc);

    // RFHighlights
    const [redFlags, setRedFlags] = useState([]);
    const { isAuth, user } = useSelector((state) => state.user);

    useEffect(() => {
        if (isAuth && user && user.preferences) {
          const textSize = user.preferences.textSize;
    
          switch (textSize) {
            case 0: // Small
                document.documentElement.style.setProperty('--analysis-font-size-header', '0.8vw');
                document.documentElement.style.setProperty('--analysis-font-size-label', '10px');
                document.documentElement.style.setProperty('--analysis-font-size-button', '0.8vw');
                break;
            case 1: // Medium (default)
                document.documentElement.style.setProperty('--analysis-font-size-header', '1vw');
                document.documentElement.style.setProperty('--analysis-font-size-label', '12px');
                document.documentElement.style.setProperty('--analysis-font-size-button', '1vw');
                break;
            case 2: // Large
                document.documentElement.style.setProperty('--analysis-font-size-header', '1.3vw');
                document.documentElement.style.setProperty('--analysis-font-size-label', '16px');
                document.documentElement.style.setProperty('--analysis-font-size-button', '1.5vw');
                break;
            default:
              break;
          }
        } else if (!isAuth) { 
            document.documentElement.style.setProperty('--analysis-font-size-header', '1vw');
            document.documentElement.style.setProperty('--analysis-font-size-label', '12px');
            document.documentElement.style.setProperty('--analysis-font-size-button', '1vw');
          }
        }, [user, isAuth]);

    useEffect(() => {
        if (analysis){
            setRedFlags(analysis.redflags);
        }
    }, [analysis]);

    const handleClick = (ref) => {
        console.log(ref);
        if (ref) {
            ref.scrollIntoView({ behavior: 'smooth' });
        }
    }

    const severities = {
        high: "severeRF",
        medium: "mediumRF",
        low: "lowRF",
    };

    return (
        <div className="redFlagsResults">
            <p className="resultsExplanation">Red flags indicate parts in the contract where the contract asks for things you may not want to give up.</p>
            <div key="showResults" className="redFlagsList">
                {redFlags.map( (element, index) => {
                    return <li key={index} className={"redFlagsOutput resultsList " + (severities[element.hasOwnProperty("severity") ? element.severity : "medium"])}
                        ref={(e) => {element.oref = e}}
                        onClick={()=>handleClick(element.ref, index)}>{element.summary}</li>
                })}
            </div>
        </div>
    );
}

export default RedFlags;